import { render, staticRenderFns } from "./ReferenceTagChip.vue?vue&type=template&id=729d461f&scoped=true&"
import script from "./ReferenceTagChip.vue?vue&type=script&lang=js&"
export * from "./ReferenceTagChip.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceTagChip.vue?vue&type=style&index=0&id=729d461f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729d461f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
